"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const vue_1 = require("vue");
const vue_2 = require("vue");
const _hoisted_1 = { class: "col-container" };
const _hoisted_2 = { class: "left-side" };
const _hoisted_3 = { class: "right-side" };
const Card_vue_1 = __importDefault(require("../../../components/backend/Card/Card.vue"));
const AddressInfo_vue_1 = __importDefault(require("../../../components/backend/Card/CardComponents/AddressInfo.vue"));
const OpeningHours_vue_1 = __importDefault(require("../../../components/backend/Card/CardComponents/OpeningHours.vue"));
const CardStatus_vue_1 = __importDefault(require("../../../components/backend/Card/CardComponents/CardStatus.vue"));
const ServiceStations_vue_1 = __importDefault(require("../../../components/backend/Card/CardComponents/ServiceStations.vue"));
const CustomButton_vue_1 = __importDefault(require("../../../components/backend/CustomButton.vue"));
exports.default = (0, vue_1.defineComponent)({
    __name: 'LocationElement',
    setup(__props) {
        const openingHours = [
            { dayName: "Hétfő", open: "08:00 - 17:00" },
            { dayName: "Kedd", open: "08:00 - 17:00" },
            { dayName: "Szerda", open: "08:00 - 17:00" },
            { dayName: "Csütörtök", open: "08:00 - 17:00" },
            { dayName: "Péntek", open: "08:00 - 17:00" },
            { dayName: "Szombat", open: "zárva" },
            { dayName: "Vasárnap", open: "zárva" },
        ];
        const serviceStations = ["3 aktív", "1 inaktív"];
        return (_ctx, _cache) => {
            const _component_font_awesome_icon = (0, vue_2.resolveComponent)("font-awesome-icon");
            return ((0, vue_2.openBlock)(), (0, vue_2.createBlock)(Card_vue_1.default, { title: "Nyíregyháza01" }, {
                default: (0, vue_2.withCtx)(() => [
                    (0, vue_2.createVNode)(CardStatus_vue_1.default, { active: true }),
                    (0, vue_2.createVNode)(AddressInfo_vue_1.default, {
                        address: "4400 Nyíregyháza Nyugati 1 utca 12.",
                        contact: "06 42 / 204 080, info@marso.hu"
                    }),
                    (0, vue_2.createElementVNode)("div", _hoisted_1, [
                        (0, vue_2.createElementVNode)("div", _hoisted_2, [
                            (0, vue_2.createVNode)(OpeningHours_vue_1.default, { days: openingHours })
                        ]),
                        (0, vue_2.createElementVNode)("div", _hoisted_3, [
                            (0, vue_2.createVNode)(ServiceStations_vue_1.default, { stations: serviceStations })
                        ])
                    ]),
                    (0, vue_2.createVNode)(CustomButton_vue_1.default, {
                        to: "/admin/locations/edit",
                        "default-icon": false,
                        "btn-type": "transparent"
                    }, {
                        default: (0, vue_2.withCtx)(() => [
                            (0, vue_2.createVNode)(_component_font_awesome_icon, {
                                class: "icon",
                                icon: ['far', 'pen-to-square']
                            }),
                            (0, vue_2.createTextVNode)(" Telephely szerkesztése")
                        ]),
                        _: 1
                    })
                ]),
                _: 1
            }));
        };
    }
});
